<template>
  <el-menu class="sidebar" :default-active="defaultActive" :router="true">
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/user">
      <el-image
        class="menu-image"
        :src="require('@/assets/images/user-menu.png')"
      ></el-image>
      平台用戶
    </el-menu-item>
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/staff">
      <el-image
        class="menu-image"
        :src="require('@/assets/images/staff-menu.png')"
      ></el-image
      >職員</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/answer-record">
      <el-image
        class="menu-image"
        :src="require('@/assets/images/answer-record.png')">
      </el-image>
      答題記錄
    </el-menu-item>
    <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/learningRankingList">
      <el-image
          class="menu-image"
          :src="require('@/assets/images/menu-phb.png')">
      </el-image>
      學習排行榜
    </el-menu-item>
    <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/student"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/Iconionic-md-people.png')"
      ></el-image
      >學生列表</el-menu-item
    >
<!--    <el-submenu index="2-4">-->
<!--      <template slot="title">-->
<!--        <el-image-->
<!--            style="width: 34px; height: 32px;margin-right:16px;"-->
<!--            :src="require('@/assets/images/Iconionic-md-people.png')"-->
<!--        ></el-image>-->
<!--        <div>學生信息</div>-->
<!--      </template>-->
<!--      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/student">學生列表</el-menu-item>-->
<!--      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId"  index="/answer-record">答題記錄</el-menu-item>-->
<!--      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/learningRankingList">學習排行榜</el-menu-item>-->
<!--    </el-submenu>-->
    <el-submenu index="1-4">
      <template slot="title">
        <el-image
          style="width: 34px; height: 32px;margin-right:16px;"
          :src="require('@/assets/images/teaching-menu.png')"
        ></el-image>
        <div>教學內容</div>
      </template>
      <el-menu-item v-if="adminUserInfoRoleId !== teacherRoleId"  index="/evaluate">評估</el-menu-item>
      <el-menu-item v-if="adminUserInfoRoleId !== teacherRoleId" index="/topic">課題</el-menu-item>
      <el-menu-item v-if="adminUserInfoRoleId !== teacherRoleId" index="/practice">練習</el-menu-item>
      <el-menu-item v-if="adminUserInfoRoleId !== teacherRoleId" index="/question">題目</el-menu-item>
      <el-menu-item index="/job">佈置作業</el-menu-item>
      <el-menu-item index="/studentJob">學生作業</el-menu-item>
    </el-submenu>
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/order"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/order-menu.png')"
      ></el-image
      >訂單</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/report"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/report-menu.png')"
      ></el-image
      >報告</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/promote"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/extension-code-menu.png')"
      ></el-image
      >推廣碼</el-menu-item
    >
    <el-menu-item index="/personalInformation"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/information-menu.png')"
      ></el-image
      >個人資料</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/returnProblem"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/problem-menu.png')"
      ></el-image
      >回報問題</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId && userInfoRoleRoleId !==editorRoleId" index="/branchStudentNumber"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/questionnaire.png')"
      ></el-image
      >分校學生編號表</el-menu-item
    >
    <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/setting"
      ><el-image
        class="menu-image"
        :src="require('@/assets/images/material-settings-overscan.png')"
      ></el-image
      >設定</el-menu-item
    >
  </el-menu>
</template>

<script>
export default {
  computed: {
    defaultActive() {
      const path = this.$route.path;
      const re = /^(\/[^/]*)/g;
      return re.exec(path)[1];
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 240px;
  min-height: 100vh;
  height: 100%;
  text-align: left;
  font-size: 26px;
  font-weight: bold;
  margin: 0 !important;
  background-color: $themeColor;
}
.el-menu {
  margin: 0 !important;
  background-color: #fff !important ;
}
.menu-image {
  width: 30px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-menu-item {
  background-color: #fff;
  margin-bottom: 8px;
  margin: 0 20px;
  display: flex;
  align-content: center;
  align-items: center;
}
.el-menu-item:nth-child(1){
  margin-top: 16px;
}
.is-active {
  background-color: #f6c98e;
  border-radius: 10px;
  color: #000;
}
::v-deep {
  .el-submenu__title {
    display: flex;
    padding-left: 20px;
    align-items: center;
    margin: 0 10px;
  }
}
</style>
